<!--
* @Name：自定义附件预览和下载功能
* @Author: 刘玉
* @Date: 2022-01-04 11:05:48
* @Last Modified by: 刘玉
* @Last Modified time: 2022-01-04 11:05:48
-->
<template>
  <div>
    <van-cell v-for="item in attachList" :key="item.attachId">
      <!--      <a @click="download(item)" style="color: #409eff">{{ item.attachName }}</a>-->
      <a @click="preview(item)" class="title-class">{{ item.attachName }}</a>
    </van-cell>
  </div>
</template>

<script>
import Bridge from '@/components/dsbridge.js'
import { presignedUrl } from '@/api/oss'
export default {
  name: 'HiAttachment',
  components: {},
  data() {
    return {}
  },
  props: {
    attachList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    /* download(item) {
      const src = item.attachUri
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      // eslint-disable-next-line no-useless-escape
      iframe.src = 'javascript: \'<script>location.href="' + src + '"<\/script>\''
      document.getElementsByTagName('body')[0].appendChild(iframe)
    }*/
    preview(item) {
      const params = {
        objectName: item.attachPath
      }
      presignedUrl(params).then(res => {
        if (res.success) {
          console.info('附件地址：' + res.data.url)
          const fileInfo = Object()
          fileInfo.displayName = item.attachName
          fileInfo.fileUrl = res.data.url
          fileInfo.fileType = item.attachFormat
          fileInfo.sourceId = item.attachPath
          fileInfo.showWaterMarkView = false
          fileInfo.moduleType = 'srm'
          Bridge.callMethodSyn('app.showAttachment', JSON.stringify(fileInfo))
        } else {
          this.$notify({ type: 'warning', message: '文件地址获取失败！' })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  color: #409eff;
  font-size: 17px;
}
</style>
